import { getParam } from '../helpers/parameters'
import { attachBearerToken } from './attach-bearer-token'
import { fetchGetJson } from './fetch-get-json'

export const fetchAcademyApi = async (
  relativePath,
  config = { method: 'GET' }
) => {
  const academyApiUrl = await getParam('academyApiUrl')

  const url = `${academyApiUrl}${relativePath}`
  return fetchGetJson(url, await attachBearerToken(config))
}



// WEBPACK FOOTER //
// ./src/services/academy-api.js